export default {
  //   素材
  MyGallery: '我的图库',
  newWork: '新建目录',
  newNmae: '重命名',
  work: '目录名称',
  new: '新建',
  delWork: '删除目录',
  deleteTip: '此操作将永久删除该文件，是否继续？',
  movecategory: '移动目录',
  isWork: '目标目录',
  workName: '图片名称',
  UploadMaterial: '上传素材',
  uploadTip: '请上传图片，支持jpg/png格式，大小不超过20MB',
  uploadSuccess: '上传成功',
  uploadFail: '上传失败',
  sFail: '部分上传失败',
  empty: '暂无素材',
  empty1: '暂无素材,请去上传!',
  empty2: '暂无选中素材！!',
  Filepath: '文件路径',
  FileSize: '文件大小',
  FileProportion: '文件比例',
  UploadTime: '上传时间',
  updateTime: '修改时间',
  remark: '备注',
  delTitle: '仅删除目录',
  delTitles: '删除目录及图片',
  delTitleTip: '仅删除目录，图片自动移入默认目录',
  Free: '自由裁剪',
  move: '移动',
};
